import { Flex, Typography } from "antd"
import cls from "classnames"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import ButtonComponent from "../../../../Components/Button"
import IntegrationAnimation from "../../../../Components/IntegrationAnimation"
import Icon from "../../../../Icon"
import Images from "../../../../Images"

import "./styles.less"

const { Text } = Typography

const data = {
  missing_stripe_connection: {
    //icon: 'plugin_connect_slim',
    component: (
      <img
        src={Images.stripe_connect_banner}
        alt=""
        width="36px"
        style={{ border: "1px solid #E1E1E2", borderRadius: "10px" }}
      />
    ),
    title: "Connect Stripe to Access This Page",
    description:
      "This page is only available to users with an active Stripe connection. To view detailed payment and dispute information, please connect your Stripe account.",
    btnText: "Connect Stripe now",
    bntLink: "https://dashboard.stripe.com/login"
  },
  missing_stripe_permissions: {
    //icon: 'triangle_exclamation_slim',
    component: (
      <img
        src={Images.stripe_connect_banner}
        alt=""
        width="36px"
        style={{ border: "1px solid #E1E1E2", borderRadius: "10px" }}
      />
    ),
    title: "Your Stripe Access Needs an Update",
    description:
      "Your current Stripe connection doesn’t grant access to the data needed for this page. Please update your Stripe access to continue using all features.",
    btnText: "Update Permissions",
    bntLink: "https://dashboard.stripe.com/login"
  },
  stripe_report_in_progress: {
    title: "Processing your data",
    description:
      "Your Stripe data is being processed. It may take some time. We’ll notify you by email as soon as it’s complete.",
    component: <IntegrationAnimation icon={<img src={Images.switcher_stripe} width={20} />} />
  },
  missing_shopify_connection: {
    component: (
      <img
        src={Images.shopify_connect_banner}
        alt=""
        width="36px"
        style={{ border: "1px solid #E1E1E2", borderRadius: "10px" }}
      />
    ),
    title: "Connect Shopify to Access This Page",
    description:
      "This page is only available to users with an active Shopify connection. To view detailed payment and dispute information, please connect your Shopify account.",
    btnText: "Connect Shopify now",
    bntLink: "https://www.shopify.com/login"
  },
  shopify_report_in_progress: {
    title: "Processing your data",
    description:
      "Your Shopify data is being processed. It may take some time. We’ll notify you by email as soon as it’s complete.",
    component: <IntegrationAnimation icon={<img src={Images.switcher_shopify} width={20} />} />
  }
}

const HealthBanner = ({ type }) => {
  const { t } = useTranslation()
  const { userInfo } = useSelector((state) => state.auth)
  const { is_business_health_available, warning_notification } = useSelector(
    (state) => state.health.mainInfo
  )

  const isDemo = userInfo?.is_demo
  const hasNoBusinessAccount = !isDemo && !userInfo?.current_business_account_id

  if (is_business_health_available || !warning_notification) return null

  let { icon, component, title, description, btnText, bntLink, btnDisabled } =
    data?.[warning_notification] ?? {}

  return (
    <div className={cls("health-banner", type)}>
      <div className="health-banner-content">
        {icon ? <Icon type={icon} style={{ fontSize: 32 }} /> : null}
        {component ? component : null}

        <Flex gap={8} vertical style={{ marginTop: 16, marginBottom: 24 }}>
          <Text strong style={{ fontSize: 16 }}>
            {t(title)}
          </Text>
          <Text type="secondary">{t(description)}</Text>
        </Flex>
        {btnText && (
          <ButtonComponent
            type="primary"
            size="large"
            target="_blank"
            rel="noopener noreferrer"
            text={t(btnText)}
            href={bntLink}
            disabled={btnDisabled || isDemo || hasNoBusinessAccount}
          />
        )}
      </div>
    </div>
  )
}

export default HealthBanner
